var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReports = function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15 2.5a.65.65 0 0 1 .643.554l.007.096v14c0 .701.536 1.278 1.22 1.344l.13.006h16a.65.65 0 0 1 .096 1.293l-.096.007h-16a2.653 2.653 0 0 1-2.645-2.482L1.5 17.15v-14a.65.65 0 0 1 .65-.65zm4 8a.65.65 0 0 1 .643.554l.007.096v4a.65.65 0 0 1-1.293.096L5.5 15.15v-4a.65.65 0 0 1 .65-.65zm4-4a.65.65 0 0 1 .643.554l.007.096v8a.65.65 0 0 1-1.293.096L9.5 15.15v-8a.65.65 0 0 1 .65-.65zm4 2a.65.65 0 0 1 .643.554l.007.096v6a.65.65 0 0 1-1.293.096l-.007-.096v-6a.65.65 0 0 1 .65-.65zm4-4a.65.65 0 0 1 .643.554l.007.096v10a.65.65 0 0 1-1.293.096l-.007-.096v-10a.65.65 0 0 1 .65-.65z"
  })));
};

export default SvgReports;